import { SVGProps, Ref, forwardRef } from 'react';

export const EnvelopeOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 7.332C0 3.332 1.333 2 5.332 2h5.332c3.999 0 5.332 1.333 5.332 5.332v1.333c0 3.999-1.333 5.332-5.332 5.332H5.332C1.333 13.997 0 12.664 0 8.665zm1.865-2.78c-.273.5-.465 1.332-.465 2.78v1.333c0 1.922.338 2.757.756 3.175s1.254.757 3.176.757h5.332c1.922 0 2.758-.339 3.176-.757s.756-1.254.756-3.175V7.332c0-1.448-.192-2.28-.465-2.78L7.998 9.568zm11.128-.878c-.513-.168-1.25-.274-2.329-.274H5.332c-1.08 0-1.816.106-2.328.274L7.998 7.76z"
                fill="currentColor"
            />
        </g>
    </svg>
));
EnvelopeOutlinedSize16Glyph.displayName = 'EnvelopeOutlinedSize16Glyph';
